import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IonIcon, IonButton } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { closeOutline } from 'ionicons/icons';

@Component({
  selector: 'app-dismissible-banner',
  standalone: true,
  imports: [IonIcon, IonButton],
  templateUrl: './dismissible-banner.component.html',
  styleUrls: ['./dismissible-banner.component.scss'],
})
export class DismissibleBannerComponent {
  @Input() icon = '';
  @Input() title = '';
  @Input() subtitle = '';
  @Input() actionLabel = '';
  /** 'accent' (blue, inline) is used for the install banner; 'success' (green, floating) for the update banner. */
  @Input() variant: 'accent' | 'success' = 'accent';
  /** 'inline' sits in the normal document flow; 'top' floats fixed at the top of the viewport. */
  @Input() position: 'inline' | 'top' = 'inline';

  @Output() action = new EventEmitter<void>();
  @Output() dismissed = new EventEmitter<void>();

  constructor() {
    addIcons({ closeOutline });
  }
}
